import { FC } from 'react';

interface YouTubePlayerProps {
  videoId: string;
  width?: string | number;
  height?: string | number;
  autoplay?: boolean;
}

const YouTubePlayer: FC<YouTubePlayerProps> = ({
  videoId,
  width = '100%',
  height = '100%',
  autoplay = false,
}) => {
  const params = new URLSearchParams({ playsinline: '1' });
  if (autoplay) params.set('autoplay', '1');
  const embedUrl = `https://www.youtube.com/embed/${videoId}?${params.toString()}`;

  return (
    <div
      style={{
        position: 'relative',
        width,
        height,
        overflow: 'hidden',
      }}
    >
      <iframe
        src={embedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </div>
  );
};

export default YouTubePlayer;
